import styled from 'styled-components';
import { vars, pxToRem, media } from '$util/theme';
import VrmIcon from '$public/img/svg/icon_vrm.svg';
import VrmBlueIcon from '$public/img/svg/icon_vrm_blue.svg';
import EmailIcon from '$public/img/svg/icon_email_grey.svg';
import EmailBlueIcon from '$public/img/svg/icon_email_blue.svg';
import { Button } from '@/components/atoms/Button';
import { Title } from '@/components/atoms/Title';

export const Container = styled.div`
  padding: 30px;
  display: block;
  width: auto;
  margin: auto;

  &.restricted {
    max-width: 1050px;
    input {
      height: 48px !important;
      background-position: right 10px bottom 14px !important;
      @media (device-height: 568px) and (device-width: 320px) and (-webkit-min-device-pixel-ratio: 2) {
        width: 100% !important;
        min-width: 0 !important;
      }
    }
  }

  .susbcribe-container {
    padding-top: 8px;
    padding-left: 8px;
  }

  ${media.down('sm')} {
    border: 0;
    max-width: 100%;
    padding: 20px;
  }

  label {
    opacity: 1 !important;
    position: relative;
    padding: 0 !important;
    font-size: unset !important;
    color: unset !important;
    display: block;
    transform: unset !important;
    line-height: unset !important;
  }

  p {
    margin-bottom: 15px;
  }

  .error-input-message {
    color: ${vars.red};
    font-size: ${pxToRem(12)};
    padding-top: 5px;
    text-align: left;
  }

  .input {
    &.vrm {
      background-image: url(${VrmIcon});
    }
    &.email {
      background-image: url(${EmailIcon});
    }
    background-repeat: no-repeat;
    background-position: right 10px bottom 18px;
    transition: all 0.5s ease-out;
    margin-top: 10px;
    display: block;
    padding: 15px 10px !important;

    &:focus {
      &.vrm {
        background-image: url(${VrmBlueIcon});
      }
      &.email {
        background-image: url(${EmailBlueIcon});
      }
      background-repeat: no-repeat;
      background-position: right 10px bottom 18px;
    }

    &::placeholder {
      color: ${vars.placeholder};
    }
  }
`;

export const TitleStyled = styled(Title)`
  margin: 25px 0;
  ${media.down('sm')} {
    font-size: 20px;
    font-weight: 500;
  }
  &.subscriber-bar {
    color: rgb(16, 130, 234);
    font-size: 19px;
    font-weight: 600;
    max-width: 66%;
    line-height: 27px;
    ${media.down('sm')} {
      max-width: 100%;
      line-height: unset;
      font-size: 17px !important;
    }
  }
`;

export const PrimaryButtonStyled = styled(Button)`
  margin: 24px auto;
  padding: 22px;
  ${media.down('sm')} {
    position: fixed;
    bottom: 30px;
    margin: 0 auto;
    left: 0;
    right: 0;
  }

  strong {
    font-size: ${pxToRem(18)};
  }
  span {
    text-align: center;
    width: 100%;
    display: block;
  }
`;

export const SubscriberBarButton = styled(Button)`
  margin: auto;
  margin-top: 25px;
  height: 48px !important;
  ${media.down('sm')} {
    margin-left: 7px;
    width: 100%;
    padding: 0 !important;
    text-align: center;
    font-size: 14px;
  }
  span {
    margin: auto;
  }
`;

/**
 * @deprecated
 */
export const GreyButton = styled(Button)`
  background: rgb(255, 255, 255) !important;
  border: 1px solid rgb(212, 220, 232) !important;
  display: inline-block !important;
  margin-right: 10px;
  margin-top: 10px;
  height: 45px !important;
  width: 115px;
  color: rgb(50, 56, 62) !important;
  font-weight: normal !important;
  &.selected {
    border: 1px solid rgb(16, 130, 234) !important;
    color: rgb(16, 130, 234) !important;
    background: rgba(16, 130, 234, 0.08) !important;

    box-shadow: inherit !important;
  }
`;
